import type { SvgIconProps, Theme } from "@mui/material";
import { SvgIcon, useTheme } from "@mui/material";
import clsx from "clsx";
import { cloneElement, forwardRef } from "react";

export type ColorGetter = string | ((theme: Theme) => string);

/**
 * this factory can be used to wrap basic SVGs from files,
 * MUI SVGs with a default color, or both.
 */
export function makeSvgIcon(
  component: React.ComponentType<SvgIconProps>,
  defaultColorGetter: ColorGetter = "currentColor",
  defaultProps?: SvgIconProps,
) {
  return forwardRef<SVGSVGElement, SvgIconProps>(
    function CustomSvgIcon(props, ref) {
      const theme = useTheme();
      const htmlColor =
        typeof defaultColorGetter === "string"
          ? defaultColorGetter
          : defaultColorGetter(theme);

      const commonProps = {
        htmlColor,
        ...defaultProps,
        ...props,
        className: clsx(defaultProps?.className, props.className),
        ref,
      };

      return typeof component === "function" ? (
        // SVG file
        <SvgIcon {...commonProps} component={component} />
      ) : (
        // MUI component
        cloneElement(component, commonProps)
      );
    },
  );
}
